/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
const HomeIcon = ({ isActive = false, className = "" }) => {
  let fill;
  if (isActive === false) {
    fill = "#9a9a9a";
  } else {
    fill = "white";
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 18 18"
      fill={fill}
      test-id="bJLj7e5B"
      className={className}
    >
      <path
        d="M4.5 14.25H6.75H11.25H13.5V7.5L9 4.125L4.5 7.5V14.25ZM3 15.75V6.75L9 2.25L15 6.75V15.75H9.75H8.25H3Z"
        fill={fill}
        test-id="urBqF__R"
      />
    </svg>
  );
};

export default HomeIcon;
